
import { IVForm } from "@/types";
import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import VPasswordField from "@/vuetify-extensions/VPasswordField.vue";
import { requiredRule } from "@/utils/rules";

@Component({
  inheritAttrs: true,
  components: {
    VPasswordField,
  },
})
export default class Authentication extends Vue {
  authenticator: ((password: string) => Promise<any>) | null = null;
  loading = false;
  resolve: Function | null = null;
  reject: Function | null = null;
  icon = "mdi-account-question";
  message = "";
  title = "Authenticate";
  showDialog = false;
  password = "";
  error = "";

  @Ref()
  authenticationForm!: IVForm;

  requiredRule = requiredRule;

  close() {
    this.showDialog = false;
    this.resolve!(false);
  }

  async callAuthenticator() {
    this.error = "";
    if (!this.authenticationForm.validate()) return;
    try {
      this.loading = true;
      await this.authenticator!(this.password);
      this.loading = false;
      this.showDialog = false;
      this.resolve!(true);
    } catch (e) {
      this.loading = false;
      this.error = (e as any).errors.summary;
    }
  }

  async authenticate(authObject: IAuthenticateObject): Promise<boolean> {
    this.message = authObject.message || this.message;
    this.icon = authObject.icon || this.icon;
    this.title = authObject.title || this.title;
    this.authenticator = authObject.authenticator;
    this.showDialog = true;
    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  @Watch("showDialog")
  onShowDialogChange() {
    if (this.showDialog) return;
    this.message = "";
    this.title = "Authenticate";
    this.icon = "mdi-account-question";
    this.authenticator = null;
    this.authenticationForm.reset();
    this.password = "";
  }

  mounted() {
    window.authenticate = this.authenticate;
  }
}
